import Loadable from 'components/Loadable';
import { ROLES } from 'models/Roles';
import { IRoute } from 'models/route';
import { lazy } from 'react';

const ListNotifications = Loadable(
	lazy(() => import('modules/Notification/pages/ListNotifications')),
);
const AddNotification = Loadable(
	lazy(() => import('modules/Notification/pages/AddNotification')),
);

const UpdateNotification = Loadable(
	lazy(() => import('modules/Notification/pages/UpdateNotification')),
);

const NOTIFICATIONS_ROUTES: IRoute[] = [
	{
		path: 'notification',
		element: ListNotifications,
		name: 'Notifications',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'notification/add',
		element: AddNotification,
		name: 'Add Notification',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'notification/update/:notificationId',
		element: UpdateNotification,
		name: 'Add Notification',
		roles: [ROLES.ADMIN],
		private: true,
	},
];

export default NOTIFICATIONS_ROUTES;
